import React from 'react'
import styled from 'styled-components'
import { Page } from 'src/components/Wrappers'
import { PlaceholderTitle } from 'src/components/Typography'

const Invoices = ({ className }) => (
  <Page className={className}>
    <PlaceholderTitle>Faktury</PlaceholderTitle>
  </Page>
)

export default styled(Invoices)``
